import { Box, Typography, useTheme } from "@mui/material";
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import ShoppingListItemForm from "../ShoppingList/ShoppingListItemForm";

export const AddItemForm = ({ handleAdd }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const emptyItem = useMemo(
    () => ({
      name: "",
      quantity: 1,
      unit: "",
      notes: "",
      purchased: false,
    }),
    [],
  );

  const handleSave = useCallback(
    (newItem) => {
      handleAdd(newItem);
      // Return true to indicate form should reset (this will re-mount the form with default values)
      return true;
    },
    [handleAdd],
  );

  return (
    <Box>
      <Typography variant="h6" component="h2" gutterBottom>
        {t("frequentItems.addNewItem")}
      </Typography>

      <ShoppingListItemForm item={emptyItem} theme={theme} onSave={handleSave} />
    </Box>
  );
};

export default AddItemForm;
